import { render, staticRenderFns } from "./SensitiveDash.vue?vue&type=template&id=42ae0736&scoped=true"
import script from "./SensitiveDash.vue?vue&type=script&setup=true&lang=js"
export * from "./SensitiveDash.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SensitiveDash.vue?vue&type=style&index=0&id=42ae0736&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ae0736",
  null
  
)

export default component.exports